import { render, staticRenderFns } from "./WowzaLivestreamRecording.vue?vue&type=template&id=44ef60ff&scoped=true"
import script from "./WowzaLivestreamRecording.vue?vue&type=script&lang=js"
export * from "./WowzaLivestreamRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef60ff",
  null
  
)

export default component.exports